export const WORKBENCH_MOBILE_LIST_SCROLL_SELECTOR = '.app-workbench__table-panel--mobile .app-workbench__mobile-scroll';

export const WORKBENCH_MOBILE_SCROLL_CHROME_ACTIVE_CLASS = 'app-workbench-mobile-scroll-chrome-active';
export const WORKBENCH_MOBILE_SCROLL_CHROME_HIDDEN_CLASS = 'app-workbench-mobile-chrome-hidden';

export const MOBILE_SCROLL_CHROME_TOP_SHOW = 8;
export const MOBILE_SCROLL_CHROME_HIDE_AT = 28;
export const MOBILE_SCROLL_CHROME_UP_SHOW_DELTA = 6;

export function getWorkbenchMobileListScrollEl(root) {
	return root?.querySelector(WORKBENCH_MOBILE_LIST_SCROLL_SELECTOR) ?? document.querySelector(WORKBENCH_MOBILE_LIST_SCROLL_SELECTOR);
}

export function scrollWorkbenchMobileListToTop({ behavior = 'smooth' } = {}) {
	getWorkbenchMobileListScrollEl()?.scrollTo({ top: 0, behavior });
}

export function setWorkbenchMobileScrollChromeHidden(hidden) {
	document.body.classList.toggle(WORKBENCH_MOBILE_SCROLL_CHROME_HIDDEN_CLASS, hidden);
}

export function updateWorkbenchMobileScrollOffset({ hidden = false, chromeEl } = {}) {
	if (typeof document === 'undefined') {
		return;
	}

	if (hidden) {
		document.documentElement.style.setProperty('--workbench-mobile-scroll-offset', '0px');
		return;
	}

	const navbar = document.getElementById('navbar');
	const navHeight = navbar?.getBoundingClientRect().height ?? 0;
	const chromeHeight = chromeEl?.getBoundingClientRect().height ?? 0;
	document.documentElement.style.setProperty('--workbench-mobile-scroll-offset', `${navHeight + chromeHeight}px`);
}

/** 绑定滚动容器：下滑收起顶栏，回顶/上滑恢复 */
export function bindMobileScrollChromeHide(scrollEl, { onHiddenChange, chromeEl } = {}) {
	if (!scrollEl) {
		return () => {};
	}

	let lastScrollY = Math.max(0, scrollEl.scrollTop);
	let hidden = document.body.classList.contains(WORKBENCH_MOBILE_SCROLL_CHROME_HIDDEN_CLASS);

	const apply = () => {
		const scrollY = Math.max(0, scrollEl.scrollTop);
		const delta = scrollY - lastScrollY;

		if (scrollY <= MOBILE_SCROLL_CHROME_TOP_SHOW) {
			hidden = false;
		} else if (scrollY >= MOBILE_SCROLL_CHROME_HIDE_AT) {
			hidden = true;
		} else if (delta < -MOBILE_SCROLL_CHROME_UP_SHOW_DELTA) {
			hidden = false;
		}

		setWorkbenchMobileScrollChromeHidden(hidden);
		updateWorkbenchMobileScrollOffset({ hidden, chromeEl });
		onHiddenChange?.(hidden);
		lastScrollY = scrollY;
	};

	apply();
	scrollEl.addEventListener('scroll', apply, { passive: true });

	const onTouchEnd = () => {
		window.requestAnimationFrame(apply);
	};
	scrollEl.addEventListener('touchend', onTouchEnd, { passive: true });
	scrollEl.addEventListener('touchcancel', onTouchEnd, { passive: true });

	return () => {
		scrollEl.removeEventListener('scroll', apply);
		scrollEl.removeEventListener('touchend', onTouchEnd);
		scrollEl.removeEventListener('touchcancel', onTouchEnd);
		setWorkbenchMobileScrollChromeHidden(false);
		updateWorkbenchMobileScrollOffset({ hidden: false, chromeEl: null });
		document.documentElement.style.removeProperty('--workbench-mobile-scroll-offset');
	};
}
